import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { PluginStoreModel } from "@bitwarden/web-vault/app/models/store/plugin.store.model";

export class PluginParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Plugin parser version ${version}`);
    }

    switch (version) {
      case 0:
        return PluginParser_v0;
    }
  }

  override getSupportedVersion(): number[] {
    return [0];
  }
}

const PluginParser_latest = (key: PluginStoreModel) => key;

const PluginParser_v0 = PluginParser_latest;
